import React from 'react'
import { Box, Typography, Grid, Select, TextareaAutosize, Button, Modal, Snackbar, Alert, Menu, MenuItem, SvgIcon, CircularProgress } from '@mui/material'
import ItemsList from './ItemsList'
import { useRedirect } from 'react-admin'
import globalStyles from '../../utils/globalStyles'
import axios from 'axios'
import legolasApi from '../../api/legolas'
import AddressForm from '../customer/AddressForm'
import generateToken from '../../utils/generateToken'
import { isEmpty } from 'lodash'
import moment from 'moment';

const formatOrderStatus = (status, deliveryMethod) => {
  const normalized = String(status || "").trim().toLowerCase();
  if (["complete",].includes(normalized)) return "ORDER SHIPPED";
  if (normalized === "delivered" && deliveryMethod === "store_pickup") return "ORDER PICKED";
  return normalized.replace(/_/g, " ").toUpperCase();
};

const UpdateOrderStatus = ({
  orderId,
  onUpdated,
  onError
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [statuses, setStatuses] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const open = Boolean(anchorEl);

  React.useEffect(() => {
    axios
      .get(`${legolasApi.url}/orders/status/list`)
      .then((res) => {
        if (res.data?.success) {
          setStatuses(res.data.data || []);
        } else {
          onError(res.data?.message || 'Unable to load order statuses.');
        }
      })
      .catch((error) => {
        onError('Unable to load order statuses. Please refresh and try again.');
      });
  }, [onError]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleStatusUpdate = async (statusId) => {
    handleClose();

    try {
      setLoading(true);

      const response = await axios.post(
        `${legolasApi.url}/orders/status/update`,
        {
          order_id: orderId,
          status_id: statusId
        }
      );

      if (response.data?.success) {
        if (onUpdated) {
          onUpdated(response.data.data, response.data.message);
        }
      } else {
        onError(response.data?.message || 'Unable to update order status.');
      }

    } catch (error) {
      onError(error.response?.data?.message || 'Unable to update order status. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const updateStatuses = [
    { label: 'CANCELLED', names: ['cancelled'] },
    { label: 'DELIVERED', names: ['delivered'] },
    { label: 'SHIPPED RETURN', names: ['shipped_returned'] }
  ].map(({ label, names }) => {
    const status = statuses.find(item => names.includes(String(item.name || '').trim().toLowerCase()));
    return status ? { ...status, label } : null;
  }).filter(Boolean);

  return (
    <>
      <Button
        id="order-status-update-button"
        aria-label="Update order status"
        aria-haspopup="menu"
        aria-expanded={open ? "true" : undefined}
        aria-controls={open ? "order-status-menu" : undefined}
        variant="contained"
        disableElevation
        size="small"
        disabled={loading}
        onClick={handleClick}
        endIcon={loading ? (
          <CircularProgress size={14} color="inherit" />
        ) : (
          <SvgIcon sx={{ fontSize: 18, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 150ms ease' }}>
            <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z" />
          </SvgIcon>
        )}
        sx={{
          backgroundColor: globalStyles.createButton.backgroundColor,
          color: "#fff",
          textTransform: "uppercase",
          minWidth: 104,
          height: 32,
          px: 1.75,
          borderRadius: "16px",
          fontSize: "0.75rem",
          fontWeight: 600,
          whiteSpace: "nowrap",
          letterSpacing: '0.025em',
          '& .MuiButton-endIcon': { ml: 0.5 },
          '&.Mui-focusVisible': { outline: '3px solid #b8c6eb', outlineOffset: 2 },
          "&:hover": { backgroundColor: globalStyles.colors.backgroundSecondary }
        }}
      >
        {loading ? "Updating..." : "Update"}
      </Button>

      <Menu
        id="order-status-menu"
        MenuListProps={{ "aria-labelledby": "order-status-update-button" }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ sx: {
          minWidth: 200,
          mt: 1,
          p: 0.5,
          borderRadius: 2,
          border: '1px solid #e4e8f0',
          boxShadow: '0 8px 24px rgba(43, 63, 122, 0.14)'
        } }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {!updateStatuses.length && <MenuItem disabled>No statuses available</MenuItem>}
        {updateStatuses.map((item) => (
          <MenuItem
            sx={{
              fontSize: "0.8125rem",
              fontWeight: 500,
              minHeight: 40,
              px: 1.5,
              py: 1,
              borderRadius: 1,
              color: '#2b3f7a',
              '&:hover, &.Mui-focusVisible': { backgroundColor: '#eef2fa' }
            }}
            key={item.id}
            onClick={() => handleStatusUpdate(item.id)}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>

    </>
  );
};

function OrderInfo(props) {
  const redirect = useRedirect()
  const isB2B = props.data?.summary?.admin_order_source === 'B2B';

  React.useEffect(() => {
    console.log('Order Info: ', props.data)
    console.log('Is B2B order? ', isB2B);

  }, [props.data])

  const getDeliveryShortCode = (method) => {
    switch (method?.toLowerCase()) {
      case "one_day_delivery":
      case "next_day_delivery":
        return "NEXT DAY DELIVERY"; // Next Day Delivery
      case "standard":
      case "standard_delivery":
        return "STANDARD";  // Standard Delivery
      case "store_pickup":
        return "STORE PICKUP";  // Store Pickup
      default:
        return "N/A";
    }
  };
  React.useEffect(() => {
    // axios.get(`${legolasApi.url}/admin/shipments`).then(res => res.data).then(data => {
    //   if (data.success) {
    //     setListData(data.data)
    //   }
    // })
  }, [])
  const [selectedHeaders, setSelectedHeaders] = React.useState([
    { id: 'shippingId', label: 'Shipping Partner' },
  ])
  const [showAddressform, setShowAddressform] = React.useState(false)
  const [selectedAddress, setSelectedAddress] = React.useState(null)
  const [alertSuccess, setAlertSuccess] = React.useState('')
  const [openSuccess, setOpenSuccess] = React.useState(false)
  const [alertSeverity, setAlertSeverity] = React.useState('success')
  const handleStatusError = React.useCallback((message) => {
    setAlertSeverity('error')
    setAlertSuccess(message)
    setOpenSuccess(true)
  }, [])
  // const [listData, setListData] = React.useState([])
  const { summary, items, shipment, transaction, customer, creditMemo, bundleDiscount, hyperpay_details, tabby_details, tamara_details, shipmentStore } = props.data
  const rawStoreDetails = summary?.store_details || props.data?.store_details;
  const [checkingPayLater, setCheckingPayLater] = React.useState(false);

const isPendingPayLater =
  Number(summary.fk_payment_id) === 8 &&
  summary.order_status === "PENDING";
  let store_details = rawStoreDetails;
  if (typeof rawStoreDetails === "string") {
    try {
      store_details = JSON.parse(rawStoreDetails);
    } catch (error) {
      store_details = null;
    }
  }
  const storeLocationUrl = store_details?.store_location_url
    || store_details?.urls?.[0]
    || store_details?.link?.["en-SA"]
    || store_details?.link?.["ar-SA"]
    || "";
  const [txnResponse, settxnResponse] = React.useState(() => {
    try {
      return JSON.parse(transaction?.otherData?.response_json || {});
    } catch (error) {
      console.error("Failed to parse JSON:", error);
      return {};
    }
  });
  // const computedGrandTotal = (parseFloat(summary.grand_total) || 0) + (parseFloat(summary.one_day_delivery_charge) || 0);


  const { hasInvoice, hasShipment, hasCreditMemo } = props
  const localStorageUser = localStorage.getItem('user');
  const user = JSON.parse(localStorageUser);
  const userid = user.id;
  const darkBox = {
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'space-between',
    backgroundColor: '#dcdbdb',
    padding: '10px'
  }
  const lightBox = {
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
    padding: '10px'
  }

  const handleEditClick = () => {
    //const redirectUrl = `/users/${userId}`
    //redirect(redirectUrl)
    alert('Redirect to User Details')
  }

  const formatDateAndTime = (inpDate) => {
    let retDate = ''
    const month = inpDate.toLocaleDateString('default', { month: 'short' })
    const date = inpDate.getDate()
    const year = inpDate.getFullYear()
    const formattedTime = inpDate.getHours() + ':' + inpDate.getMinutes() + ':' + inpDate.getSeconds()
    return retDate + month + '  ' + date + ',  ' + year + '  ' + formattedTime
  }

  const editAddress = (address) => {
    console.log('edit address: ', address)
    let addressData = {
      'firstname': address.customer_firstname,
      'lastname': address.customer_lastname,
      'middlename': address.customer_middlename,
      'city': address.city,
      'city_id': address.city_id,
      'district': address.district,
      'district_id': address.district_id,
      'country': address.country,
      'country_id': address.country_code,
      'street': address.street,
      'postcode': address.postcode,
      'phone_ext': address.phone_ext,
      'telephone': address.phone,
      'building_no': address.building_no,
      'premisesCode': address.premisesCode,
      'customer_unique_id': address.customer_unique_id,

    }
    setShowAddressform(true)
    setSelectedAddress(addressData)
  }

  const closeFormModal = () => {
    setShowAddressform(false)
  }

  const handleAlertSuccess = (message) => {
    setAlertSeverity('success')
    setAlertSuccess(message)
    setOpenSuccess(true)

  }
const checkPayLaterStatus = () => {
  setCheckingPayLater(true);

  axios.get(
    `${legolasApi.url}/orders/${summary.order_id}/paylater-status`
  ).then((response) => {
    const responseData = response && response.data
      ? response.data
      : {};

    if (!responseData.success) {
      throw new Error(
        responseData.message ||
        "Unable to check PayLater payment status."
      );
    }

    if (responseData.paymentStatus === "success") {
      handleAlertSuccess(
        "Payment received. Order is now processing."
      );

      setTimeout(() => {
        window.location.reload();
      }, 1500);

      return;
    }

    if (responseData.paymentStatus === "failed") {
      window.alert("Payment failed, cancelled, or expired.");
      return;
    }

    window.alert(
      "Payment is still pending. Please ask the customer to complete payment."
    );
  }).catch((error) => {
    window.alert(
      error &&
      error.response &&
      error.response.data &&
      error.response.data.message
        ? error.response.data.message
        : error.message ||
          "Unable to check PayLater payment status."
    );
  }).finally(() => {
    setCheckingPayLater(false);
  });
};
  const closeSuccess = () => {
    setOpenSuccess(false)
  }

  const AddorEditAddress = (payload, type = 'edit') => {
    switch (type) {
      case 'edit':
        const orderIdEdit = summary.order_id
        let editPayload = Object.assign(payload, { 'order_id': orderIdEdit })
        const signedTokenEdit = generateToken(editPayload)
        const resourcePayloadEdit = { "action": "update-address" }
        axios.post(`${legolasApi.url}/orders/address/update`, resourcePayloadEdit, {
          headers: {
            'Authorization': `Bearer ${signedTokenEdit}`,
            'Content-Type': 'application/json'
          }
        }).then((res) => {
          handleAlertSuccess('Address updated successfully!');
          console.log('Address Updated: ')
          console.log(res)
          setTimeout(() => {
            window.location.reload();
          }, 1000)
        })
        break
    }
  }
  const getCancellationSource = (source) => {
    if (!source) return "N/A";
    const map = { frontend: "Frontend", admin: "Admin", vinculum: "Vinculum" };
    return map[source.toLowerCase()] || source;
  };
  const getCancelledBy = (source, email) => {
    if (!source) return "N/A";
    if (source.toLowerCase() === "vinculum") {
      return "N/A";
    }
    return email || "N/A";
  };

  const formatCancellationDate = (date) => {
    if (!date) return "N/A";
    return moment(date).format("DD MMM YYYY, hh:mm A");
  };

  const AddressInfo = () => {
    return (
      <React.Fragment>
        <Box sx={{ display: 'inline' }}>
          <Typography sx={{ paddingRight: '5px', wordBreak: "break-word" }}>{shipment.customer_firstname ? shipment.customer_firstname : null}</Typography>
          <Typography sx={{ paddingRight: '5px', wordBreak: "break-word" }}>{shipment.customer_lastname ? shipment.customer_lastname : null}</Typography>
        </Box>
        <Typography sx={{ paddingRight: '5px', wordBreak: "break-word", whiteSpace: 'normal', maxWidth: '40ch' }}>{shipment.street ? shipment.street : null}</Typography>
        {/* <Typography sx={{ paddingRight: '5px', wordBreak:"break-word",whiteSpace: 'normal',maxWidth: '40ch' }}>{shipment.building_no ? shipment.building_no : null}</Typography> */}
        {/* Only show building_no if B2B */}
        {summary.admin_order_source === 'B2B' && shipment.building_no && (
          <Typography sx={{ paddingRight: '5px', wordBreak: "break-word", whiteSpace: 'normal', maxWidth: '40ch' }}>
            {shipment.building_no}
          </Typography>
        )}
        <Typography>{shipment.district ? shipment.district : null}</Typography>
        <Box sx={{ display: 'inline-flex' }}>
          <Typography>{shipment.city ? shipment.city : null}</Typography>,
          <Typography sx={{ paddingLeft: '5px' }}>{shipment.postcode ? shipment.postcode : 560034}</Typography>
        </Box>
        <Typography>{shipment.country ? shipment.country : null}</Typography>
        <Box sx={{ display: 'inline-flex' }}>
          <Typography sx={{ paddingRight: '5px' }}>T:</Typography>
          <Typography>{shipment.phone ? shipment.phone_ext + " " + shipment.phone : null}</Typography>
        </Box><br />
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <Box id='accountinfo-box'>
        <Snackbar open={openSuccess} autoHideDuration={3000} onClose={closeSuccess} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert onClose={closeSuccess} severity={alertSeverity} sx={{ width: '400px', marginTop: '100px' }}>
            {alertSuccess}
          </Alert>
        </Snackbar>
        <Box sx={{ width: '95%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
            Order & Account Information
          </Typography>
        </Box>
        <Grid container spacing={5} columns={24}>
          <Grid item xs={11}>
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
              Order # {summary.order_id}
            </Typography>
            <Box sx={darkBox}>
              <Typography>Order Date</Typography>
              <Typography>{summary.placedOn ? summary.placedOn : null}</Typography>
            </Box>
            <Box sx={{ ...lightBox, alignItems: "center", gap: 2 }}>
              <Typography sx={{ flexShrink: 0 }}>Order Status</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexWrap: 'wrap', gap: 1 }}>
                <Typography sx={{ fontSize: '0.875rem', fontWeight: 500 }}>
                  {formatOrderStatus(summary.order_status, summary.delivery_method)}
                </Typography>
                {["complete", "order shipped"].includes((summary.order_status || "").trim().toLowerCase()) && (
                  <UpdateOrderStatus
                    orderId={summary.order_id}
                    onError={handleStatusError}
                    onUpdated={(updated, message) => {
                      props.onStatusUpdated(updated);
                      handleAlertSuccess(message || "Order status updated successfully!");
                    }}
                  />
                )}
              </Box>
            </Box>
            <Box sx={darkBox}>
              <Typography>Payment Method </Typography>
              <Typography>{summary.payment_method_code == "online" ? "debit/credit cards" : summary.payment_method_code ? summary.payment_method_code : null}</Typography>
            </Box>
            <Box sx={lightBox}>
              <Typography>Purchased From</Typography>
              <Box sx={{ display: 'block', textAlign: 'end' }}>
                <Typography>{summary.store_name}</Typography>
              </Box>
            </Box>
            <Box sx={darkBox}>
              <Typography>Channel </Typography>
              <Typography>{summary.channel ? summary.channel : "Shababuna"}</Typography>
            </Box>
            {/* <Box sx={lightBox}>
              <Typography>Next Day Delivery </Typography>
              <Typography>{Number(summary.one_day_delivery_charge) > 0 ? "True" : "False"}</Typography>
            </Box> */}
            <Box sx={lightBox}>
              <Typography>Delivery Type</Typography>
              <Typography>
                {getDeliveryShortCode(summary.delivery_method)}
              </Typography>
            </Box>
            {summary?.pickup_otp && (
              <Box sx={darkBox}>
                <Typography>Pickup OTP</Typography>
                <Typography>{summary.pickup_otp}</Typography>
              </Box>
            )}
            {isB2B && (
              <Box sx={darkBox}>
                <Typography>Sales Person Name </Typography>
                <Typography> {summary.sales_person_name?.trim() || "N/A"}</Typography>
              </Box>
            )}
            <Grid item xs={11}>
              <Box sx={{ display: 'inline-flex', justifyContent: 'space-evenly' }}>
                <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
                </Typography>

              </Box>
            </Grid>
            {(summary.cancel_reason || summary.cancel_source) && (
              <Grid item xs={24}>
                <Box sx={{ width: "100%", borderBottom: "1px solid #000", marginBottom: "20px", paddingBottom: "10px" }}>
                  <Typography variant="h6"> Order Cancellation Information</Typography>
                </Box>
                <Box sx={{ ...darkBox, display: "grid", gridTemplateColumns: "200px 1fr", alignItems: "center" }} >
                  <Typography>Cancellation Source</Typography>
                  <Typography sx={{ fontWeight: 500, textAlign: "right" }}>{getCancellationSource(summary.cancel_source)}</Typography>
                </Box>
                <Box sx={{ ...lightBox, display: "grid", gridTemplateColumns: "200px 1fr", alignItems: "center" }}>
                  <Typography>Cancelled By</Typography>
                  <Typography sx={{ textAlign: "right" }}>{getCancelledBy(summary.cancel_source, summary.cancel_email)}</Typography>
                </Box>
                {summary.cancel_reason && (
                  <Box sx={{ ...darkBox, display: "grid", gridTemplateColumns: "200px 1fr", alignItems: "start" }}>
                    <Typography>Cancellation Remarks</Typography>
                    <Typography sx={{ textAlign: "right", whiteSpace: "normal", wordBreak: "break-word", color: "text.primary" }}>
                      {summary.cancel_reason}
                    </Typography>
                  </Box>
                )}
                <Box sx={{ ...lightBox, display: "grid", gridTemplateColumns: "200px 1fr", alignItems: "center" }}>
                  <Typography>Cancellation Date</Typography>
                  <Typography sx={{ textAlign: "right" }}>{formatCancellationDate(summary.cancel_created_at)}</Typography>
                </Box>
              </Grid>
            )}
            {/*
            <Box sx={darkBox}>
              <Typography>Placed from IP</Typography>
              <Typography>NULL</Typography>
  </Box>*/}
          </Grid>

          <Grid item xs={11}>
            <Box sx={{ display: 'inline-flex', justifyContent: 'space-evenly' }}>
              <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
                Account Information
              </Typography>
              {/* <Typography
                variant='subtitle1'
                onClick={() => handleEditClick()}
                sx={{ paddingLeft: '50px', fontSize: '0.9rem', fontWeight: 700, color: '#2b3f7a', cursor: 'pointer' }}
              >
                Edit Customer
              </Typography> */}
            </Box>
            <Box sx={darkBox}>
              <Typography sx={{ marginRight: '10px' }}>Customer Name</Typography>
              <Box sx={{ display: 'inline', overflow: 'hidden', wordWrap: 'break-word', maxWidth: '100%' }}>
                {shipment.customer_firstname || shipment.customer_lastname ? (
                  <Typography sx={{ paddingRight: '5px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'normal' }}>
                    {`${shipment.customer_firstname || ''} ${shipment.customer_lastname || ''}`.trim()}
                  </Typography>
                ) : null}
              </Box>
            </Box>

            <Box sx={lightBox}>
              <Typography>Email</Typography>
              <Typography>{customer.guest_user_email ? customer.guest_user_email : customer.email}</Typography>
            </Box>
            <Box sx={lightBox}>
              <Typography>Phone</Typography>
              {shipment.phone_ext && shipment.phone ?
                <Typography>{shipment.phone_ext + shipment.phone}</Typography> : <Typography sx={{ color: 'red' }}>Email not set</Typography>}
            </Box>
            <Box sx={darkBox}>
              <Typography>Customer Group</Typography>
              <Typography>
                GENERAL
                {/* {customer.user_group_code ? customer.user_group_code :"GENERAL"}*/}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box id='addressinfo-box' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '95%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
            Address Information
          </Typography>
        </Box>
        <Grid container spacing={5} columns={24}>
          <Grid item xs={11}>
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
              Billing Address
            </Typography>
            <AddressInfo />
          </Grid>
          <Grid item xs={11}>
            {summary.delivery_method === "store_pickup" ? (
              <>
                <Typography
                  variant="subtitle1"
                  sx={{ fontSize: "1rem", fontWeight: 700 }}
                >
                  Store Address
                </Typography>
                <Box sx={{ mt: 2, p: 2, borderRadius: 2, backgroundColor: "#f8f9fb", border: "1px solid #e0e0e0", }}>
                  <Typography sx={{ fontWeight: 600 }}>
                    {store_details?.store_name}
                  </Typography>

                  <Typography sx={{ mt: 1 }}>
                    {store_details?.store_address}
                  </Typography>

                  <Typography>
                    {store_details?.district}
                  </Typography>

                  <Typography>
                    {store_details?.city}, {store_details?.country}
                  </Typography>

                  <Typography sx={{ mt: 1 }}>
                    {Array.isArray(store_details?.timing)
                      ? store_details.timing.join(', ')
                      : store_details?.timing}
                  </Typography>

                  {storeLocationUrl && (
                    <Box sx={{ mt: 2 }}>
                      <Typography sx={{ fontSize: "0.875rem", wordBreak: "break-all" }}>
                        <strong>Link:</strong>{" "}
                        <a
                          href={storeLocationUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#2b3f7a" }}
                        >
                          {storeLocationUrl}
                        </a>
                      </Typography>

                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          mt: 1.5,
                          textTransform: "none",
                          borderRadius: 2,
                          backgroundColor: "#2b3f7a",
                          boxShadow: "none",
                          '&:hover': { backgroundColor: "#1f2f5f", boxShadow: "none" },
                        }}
                        onClick={() => window.open(storeLocationUrl, "_blank", "noopener,noreferrer")}
                      >
                        📍 View on Google Maps
                      </Button>
                    </Box>
                  )}
                </Box>
              </>
            ) : (
              <>
                <Typography variant="subtitle1" sx={{ fontSize: "1rem", fontWeight: 700 }}>Shipping Address</Typography>
                {userid !== 155 && (
                  <Box>
                    <Button onClick={() => editAddress(shipment)} sx={{ textTransform: "capitalize", padding: 0 }}> Edit Address</Button>
                  </Box>
                )}
                <AddressInfo />
              </>
            )}
          </Grid>

        </Grid>
      </Box>
      <Box id='paymentinfo-box' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '95%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
            Payment & Shipping Method
          </Typography>
          <Box>

          </Box>
        </Box>
        <Grid container spacing={5} columns={24}>
          <Grid item xs={11}>
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
              Payment Information
            </Typography>
            <Box>
              <Typography>{transaction?.paymentType ? transaction?.paymentType : null}</Typography>
              {
                transaction?.last4Digits &&
                <Typography>
                  {transaction?.last4Digits}
                </Typography>
              }
              <Typography>{transaction?.paymentBrand ? transaction?.paymentBrand : null}</Typography>
              {Number(summary.extra_discount) === 1 && Number(summary.extra_discount_amount) > 0 && (
                <Typography> addlDisc (5%): SAR {parseFloat(summary.extra_discount_amount).toFixed(2)}</Typography>
              )}
              {isPendingPayLater && (
  <Box sx={{ marginTop: "15px" }}>
    <Button
      variant="contained"
      disabled={checkingPayLater}
      onClick={checkPayLaterStatus}
      sx={{
        backgroundColor: "#2b3f7a",
        color: "#fff !important",
        textTransform: "none",
        "&:hover": {
          backgroundColor: "#233566"
        }
      }}
    >
      {checkingPayLater
        ? "Checking Payment..."
        : "Check Pay Later Payment"}
    </Button>
  </Box>
)}
            </Box>
          </Grid>
          <Grid item xs={11}>
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
              Shipping & Handling Information
            </Typography>
            <Box>
              <Typography>
                {(summary.vinculumShipDetails != null) ? (summary.vinculumShipDetails[0].shipdetail[0].transporter) : 'Shababuna Shipping (default)'}
              </Typography>
            </Box>
            <Box>
              <Typography>Total Shipping Charges: <Typography sx={{ fontWeight: 700 }}>SAR {summary.shipping_incl_tax}</Typography></Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box id='payment-details-box' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '95%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
            Payment Details
          </Typography>
        </Box>
        <Grid container spacing={5} columns={24}>
          <Grid item xs={11}>
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
              Payment Registered In Our System
            </Typography>
            {/* <Typography  >{txnResponse?.result?.description||  txnResponse?.result?.msg ||  txnResponse?.status  }</Typography> */}
            <Typography>
              {(() => {
                switch (summary.payment_method_code) {
                  case "online":
                    return txnResponse?.result?.description ? txnResponse?.result?.description : "Failed to capture data";
                  case "tamara":
                    return txnResponse?.status ? txnResponse?.status : "Failed to capture data";
                  case "tabby":
                    return txnResponse?.status ? txnResponse?.status : "Failed to capture data";
                  case "cod":
                    return txnResponse?.msg ? txnResponse?.msg : "Failed to capture data";
                  case "mada":
                    return txnResponse?.result?.description ? txnResponse?.result?.description : "Failed to capture data";
                  case "apple":
                    return txnResponse?.result?.description ? txnResponse?.result?.description : "Failed to capture data"
                  default:
                    return "";
                }
              })()}
            </Typography>
          </Grid>
          <Grid item xs={11}>
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
              Current Payment Description By Payment Gatway
            </Typography>
            {/* <Typography sx={{ textTransform: "uppercase" }}>{hyperpay_details?.result?.description || tabby_details?.status || tamara_details?.status }</Typography> */}
            <Typography>
              {(() => {
                switch (summary.payment_method_code) {
                  case "online":
                    return hyperpay_details?.result?.description ? hyperpay_details?.result?.description : "cannot find transaction";
                  case "tamara":
                    return tamara_details?.status ? tamara_details?.status : "cannot find transaction";
                  case "tabby":
                    return tabby_details?.status ? tabby_details?.status : "cannot find transaction";
                  case "cod":
                    return txnResponse?.msg ? txnResponse?.msg : "cannot find transaction";
                  case "mada":
                    return hyperpay_details?.result?.description ? hyperpay_details?.result?.description : "cannot find transaction";
                  case "apple":
                    return hyperpay_details?.result?.description ? hyperpay_details?.result?.description : "cannot find transaction";
                  default:
                    return "";
                }
              })()}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      {summary?.coupon_code && (
        <Box id='coupon-details-box' sx={{ paddingTop: '50px' }}>
          <Box sx={{ width: '95%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
            <Typography variant='h6'>Coupon Details</Typography>
          </Box>
          <Grid container spacing={5} columns={24}>
            <Grid item xs={11}>
              <Typography variant='subtitle1' sx={{ fontSize: '1rem', fontWeight: 700 }}>
                Coupon Applied in Our System
              </Typography>
              <Typography sx={{ textTransform: 'uppercase' }}>
                {Number(summary?.discount_amount) > 0 ? summary?.coupon_code : "NOT"}
              </Typography>
            </Grid>

            {summary?.applied_rule_ids && (
              <Grid item xs={11}>
                <Typography variant='subtitle1' sx={{ fontSize: '1rem', fontWeight: 700 }}>
                  Applied Rule ID(s)
                </Typography>
                <Typography> {Number(summary?.discount_amount) > 0 ? summary?.applied_rule_ids : "NOT"}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      )}

      <Box id='itemsinfo-box' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '95%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
            Items Ordered
          </Typography>
        </Box>
        <Box>
          <ItemsList data={items ? items : []} ecomData={summary && summary.bundleEcomData ? summary.bundleEcomData : []} creditData={creditMemo} source='order-info' />
        </Box>
      </Box>
      <Box id='totalinfo-box' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '95%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
            Order Total
          </Typography>
        </Box>
        <Grid container spacing={5} columns={24}>
          <Grid item xs={11}>
            {summary.parent_order_id &&
              <Box>
                <Typography variant='subtitle1' sx={{ fontsize: '2rem', fontWeight: 700 }}>
                  Notes for this Order:
                </Typography>
                <Box sx={{ paddingTop: '20px', display: 'flex', flexDirection: 'column' }}>
                  {summary.parent_order_id &&
                    <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 400 }}>
                      <b>Parent Order: </b>{summary.parent_order_id}
                    </Typography>
                  }
                  {summary.comment &&
                    <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 400 }}>
                      <b>Note:</b> {summary.comment}
                    </Typography>
                  }
                </Box>
              </Box>
            }
            {
              props.datafromList &&
              <Box id='status-texts' sx={{ paddingTop: '20px' }}>
                {
                  props.datafromList.orderSuccessEmailSentAt == null ?
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', '& .MuiTypography-root': { fontSize: '14px' } }}>
                      <Typography variant='subtitle1'>{formatDateAndTime(new Date(props.datafromList.createdAt))} |</Typography>
                      <Typography variant='subtitle1'>{props.datafromList.status} |</Typography>
                      <Typography variant='subtitle1' sx={{ fontWeight: 600 }}>{props.datafromList.orderSuccessEmailSent == 1 ? 'Customer Notifed' : 'Customer Not Notified'}</Typography>
                    </Box> :
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', '& .MuiTypography-root': { fontSize: '14px' } }}>
                      <Typography variant='subtitle1'>{formatDateAndTime(new Date(props.datafromList.orderSuccessEmailSentAt))} |</Typography>
                      <Typography variant='subtitle1'>{props.datafromList.status} |</Typography>
                      <Typography variant='subtitle1' sx={{ fontWeight: 600 }}>{props.datafromList.orderSuccessEmailSent == 1 ? 'Customer Notifed' : 'Customer Not Notified'}</Typography>
                    </Box>
                }
              </Box>
            }
            {
              hasInvoice && props.datafromList &&
              <Box id='status-texts' sx={{ paddingTop: '20px' }}>
                {

                  <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', 'flex-wrap': 'wrap', '& .MuiTypography-root': { fontSize: '14px' } }}>
                    <Typography variant='subtitle1'>{formatDateAndTime(new Date(props.datafromList.createdAt))} |</Typography>
                    <Typography variant='subtitle1'>{props.datafromList.status} |</Typography>
                    <Typography variant='subtitle1' sx={{ fontWeight: 600 }}>{props.datafromList.orderSuccessEmailSent == 1 ? 'Customer Notifed' : 'Customer Not Notified'} |</Typography>
                    <Typography variant='subtitle1' sx={{ fontWeight: 600, 'padding-right': '262px' }}>Invoice Created</Typography>
                  </Box>
                }
              </Box>
            }
            {
              hasShipment && props.datafromList &&
              <Box id='status-texts' sx={{ paddingTop: '20px' }}>
                {

                  <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', 'flex-wrap': 'wrap', '& .MuiTypography-root': { fontSize: '14px' } }}>
                    <Typography variant='subtitle1'>{formatDateAndTime(new Date(props.datafromList.createdAt))} |</Typography>
                    <Typography variant='subtitle1'>{props.datafromList.status} |</Typography>
                    <Typography variant='subtitle1' sx={{ fontWeight: 600 }}>{props.datafromList.orderSuccessEmailSent == 1 ? 'Customer Notifed' : 'Customer Not Notified'} |</Typography>
                    <Typography variant='subtitle1' sx={{ fontWeight: 600, 'padding-right': '262px' }}>Shipment Created</Typography>
                  </Box>
                }
              </Box>
            }
            {
              hasCreditMemo && props.datafromList &&
              <Box id='status-texts' sx={{ paddingTop: '20px' }}>
                {

                  <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', 'flex-wrap': 'wrap', '& .MuiTypography-root': { fontSize: '14px' } }}>
                    <Typography variant='subtitle1'>{formatDateAndTime(new Date(props.datafromList.createdAt))} |</Typography>
                    <Typography variant='subtitle1'>{props.datafromList.status} |</Typography>
                    <Typography variant='subtitle1' sx={{ fontWeight: 600 }}>{props.datafromList.orderSuccessEmailSent == 1 ? 'Customer Notifed' : 'Customer Not Notified'} |</Typography>
                    <Typography variant='subtitle1' sx={{ fontWeight: 600, 'padding-right': '262px' }}>creditMemo Created</Typography>
                  </Box>
                }
              </Box>
            }
          </Grid>
          <Grid container spacing={5} columns={24} >
            <Grid item xs={12}>
              {!isEmpty(summary.notes) &&
                <Box style={{ marginLeft: "10%" }}>
                  {summary.notes.includes("B2B: ") ?
                    <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 400 }}>
                      <b>Channel: B2B</b>
                    </Typography>
                    : null}
                  <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 400, wordBreak: "break-word" }}>
                    <b>Note:</b> {summary.notes.replace("B2B: ", "")}
                  </Typography>
                  {/* <TextareaAutosize
                                 aria-label="minimum height"
                                 minRows={5}
                                 placeholder='Notes'
                                 disabled= {true}
                                //  value={summary.notes.replace("B2B : ", "")}
                                value={summary.notes}
                                 style={{ width: 300 ,marginLeft:"10%"}}
                             /> */}
                </Box>}

            </Grid>
            <Grid item xs={11}>
              <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700, paddingBottom: '20px' }}>
                Order Totals
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                <Typography>Price</Typography>
                <Typography>SAR {summary.total_price ? parseFloat(summary.total_price).toFixed(2) : (0.00).toFixed(2)}</Typography>
              </Box>
              {Number(summary.total_discount) > 0 || Number(summary.discount_amount) > 0 || (Number(summary.extra_discount) === 1 && Number(summary.extra_discount_amount) > 0) ? (
                <>
                  <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 700 } }}>
                    <Typography>Total Savings</Typography>
                    <Typography>
                      SAR {(
                        (parseFloat(summary.total_discount) || 0) +
                        (parseFloat(summary.discount_amount) || 0) +
                        (Number(summary.extra_discount) === 1 ? (parseFloat(summary.extra_discount_amount) || 0) : 0)
                      ).toFixed(2)}
                    </Typography>
                  </Box>

                  <Box sx={{ backgroundColor: '#f5f5f5', borderRadius: '8px', padding: '10px', marginTop: '5px' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingLeft: '10px', '& .MuiTypography-root': { fontSize: '14px', fontWeight: 600 } }}>
                      <Typography>Product Discount</Typography>
                      <Typography>SAR {(parseFloat(summary.total_discount) || 0).toFixed(2)}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingLeft: '10px', marginTop: '5px', '& .MuiTypography-root': { fontSize: '14px', fontWeight: 600 } }}>
                      <Typography>Coupon Discount</Typography>
                      <Typography>SAR {(parseFloat(summary.discount_amount) || 0).toFixed(2)}</Typography>
                    </Box>
                    {Number(summary.extra_discount) === 1 && Number(summary.extra_discount_amount) > 0 && (
                      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingLeft: '10px', marginTop: '5px', '& .MuiTypography-root': { fontSize: '14px', fontWeight: 600 } }}>
                        <Typography>addlDisc (5%)</Typography>
                        <Typography>SAR {parseFloat(summary.extra_discount_amount).toFixed(2)}</Typography>
                      </Box>
                    )}
                  </Box>
                </>
              ) : null}
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                <Typography>Subtotal (incl. Tax)</Typography>
                <Typography>SAR {summary.subtotal_incl_tax ? parseFloat(summary.subtotal_incl_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                <Typography>Tax</Typography>
                <Typography>SAR {summary.total_tax ? parseFloat(summary.total_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
              </Box>
              {/* {
              Number(summary.discount_amount) > 0 &&
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between',  '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                <Typography>Coupon Discount</Typography>
                <Typography>SAR {summary.discount_amount ? parseFloat(summary.discount_amount).toFixed(2) : (0.00).toFixed(2)}</Typography>
              </Box>
            } */}
              {
                Number(bundleDiscount) > 0 && (
                  <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                    <Typography>Bundle Discount</Typography>
                    <Typography>SAR {bundleDiscount ? parseFloat(bundleDiscount).toFixed(2) : (0.00).toFixed(2)}</Typography>
                  </Box>
                )}
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                <Typography>Shipping & Handling</Typography>
                <Typography>SAR {summary.shipping_incl_tax ? parseFloat(summary.shipping_incl_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
              </Box>
              {Number(summary.cod_fee_incl_tax) > 0 && (

                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                  <Typography>Cash on Delivery Fee (incl. Tax)</Typography>
                  <Typography>SAR {summary.cod_fee_incl_tax ? parseFloat(summary.cod_fee_incl_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
                </Box>
              )}

              {
                parseInt(summary.fk_payment_id) === 5 &&
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                  <Typography>Tamara Processing Fee</Typography>
                  <Typography>SAR {summary.tamara_fee_incl_tax ? parseFloat(summary.tamara_fee_incl_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
                </Box>
              }
              {
                parseInt(summary.fk_payment_id) === 6 &&
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                  <Typography>Tabby Processing Fee</Typography>
                  <Typography>SAR {summary.tabby_fee_incl_tax ? parseFloat(summary.tabby_fee_incl_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
                </Box>
              }
              {/* One-Day Delivery Fee */}
              {Number(summary.one_day_delivery_charge) > 0 && (
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                  <Typography>Next Day Delivery Fee</Typography>
                  <Typography>
                    SAR {parseFloat(summary.one_day_delivery_charge).toFixed(2)}
                  </Typography>
                </Box>
              )}
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                <Typography>Grand Total</Typography>
                <Typography>SAR {summary.grand_total ? parseFloat(summary.grand_total).toFixed(2) : (0.00).toFixed(2)}</Typography>
                {/* <Typography>SAR {computedGrandTotal.toFixed(2)}</Typography> */}
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                <Typography>Total Paid</Typography>
                <Typography>SAR {summary.total_paid ? parseFloat(summary.total_paid).toFixed(2) : (0.00).toFixed(2)}</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                <Typography>Total Refunded</Typography>
                <Typography>SAR {summary.total_refunded ? parseFloat(summary.total_refunded).toFixed(2) : (0.00).toFixed(2)}</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                <Typography>Total Due</Typography>
                <Typography>SAR {summary.total_due ? parseFloat(summary.total_due).toFixed(2) : (0.00).toFixed(2)}</Typography>
              </Box>
            </Grid>
          </Grid>
          {/* <Grid item xs={11}>

            
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700, paddingBottom: '20px' }}>
              Order Totals
            </Typography>

          
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
              <Typography>Subtotal (incl. Tax)</Typography>
              <Typography>SAR {summary.subtotal_incl_tax ? parseFloat(summary.subtotal_incl_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between',  '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
              <Typography>Tax</Typography>
              <Typography>SAR {summary.total_tax ? parseFloat(summary.total_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
            </Box>
            {
              Number(summary.discount_amount) > 0 &&
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between',  '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                <Typography>Coupon Discount</Typography>
                <Typography>SAR {summary.discount_amount ? parseFloat(summary.discount_amount).toFixed(2) : (0.00).toFixed(2)}</Typography>
              </Box>
            }
            {
              bundleDiscount > 0 &&
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between',  '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                <Typography>Bundle Discount</Typography>
                <Typography>SAR {bundleDiscount ? parseFloat(bundleDiscount).toFixed(2) : (0.00).toFixed(2)}</Typography>
              </Box>
            }
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
              <Typography>Shipping & Handling</Typography>
              <Typography>SAR {summary.shipping_incl_tax ? parseFloat(summary.shipping_incl_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between',  '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
              <Typography>Cash on Delivery Fee (incl. Tax)</Typography>
              <Typography>SAR {summary.cod_fee_incl_tax ? parseFloat(summary.cod_fee_incl_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
            </Box>
            {
              parseInt(summary.fk_payment_id) === 5 &&
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between',  '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                <Typography>Tamara Processing Fee</Typography>
                <Typography>SAR {summary.tamara_fee_incl_tax ? parseFloat(summary.tamara_fee_incl_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
              </Box>
            }
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
              <Typography>Grand Total</Typography>
              <Typography>SAR {summary.grand_total ? parseFloat(summary.grand_total).toFixed(2) : (0.00).toFixed(2)}</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
              <Typography>Total Paid</Typography>
              <Typography>SAR {summary.total_paid ? parseFloat(summary.total_paid).toFixed(2) : (0.00).toFixed(2)}</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
              <Typography>Total Refunded</Typography>
              <Typography>SAR {summary.total_refunded ? parseFloat(summary.total_refunded).toFixed(2) : (0.00).toFixed(2)}</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
              <Typography>Total Due</Typography>
              <Typography>SAR {summary.total_due ? parseFloat(summary.total_due).toFixed(2) : (0.00).toFixed(2)}</Typography>
            </Box>
          </Grid> */}
        </Grid>
        <Modal
          open={showAddressform}
          onClose={() => setShowAddressform(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <AddressForm
            address={selectedAddress}
            isOrderAddress={true}
            isB2B={summary.admin_order_source === 'B2B'} //  passing
            closeFormModal={closeFormModal}
            AddorEditAddress={AddorEditAddress}
          />
        </Modal>
      </Box>
    </React.Fragment>
  )
}

export default OrderInfo
